import { gql } from '@apollo/client';

export const LIST_GROUPS = gql`
  query ListGroups($filter: [GroupFilterInput!]!, $limit: Int, $nextToken: String) {
    listGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      name
      caseId
      items {
        id
        name
        org_id
        roles {
          role
          scope
        }
        members {
          id
          type
          identifier
        }
      }
      nextToken
    }
  }
`;
